"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconFileBoxTime = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M41.37 49.87H28.46a1.77 1.77 0 0 0-1.76 1.76v4a1.77 1.77 0 0 0 1.76 1.76h12.91a1.77 1.77 0 0 0 1.76-1.76v-4a1.77 1.77 0 0 0-1.76-1.76zm-.5 5.22H29v-3h11.9z"
  }), _react["default"].createElement("path", {
    d: "M63.62 40.05l-2-4a17.89 17.89 0 0 1-2.2 1.23l.45.89h-2.63a16.37 16.37 0 0 1-11.16.11 2.62 2.62 0 0 0-1.63 1.43l-1.63 3.62a.1.1 0 0 1-.09.06H27.09a.1.1 0 0 1-.09-.06l-1.63-3.62A2.62 2.62 0 0 0 23 38.15h-6V35h23.19a17.87 17.87 0 0 1-2.3-2.27H19.54v-4.9h15.35a17.7 17.7 0 0 1-.71-2.27h-12v-4.95h11.51a17.84 17.84 0 0 1 .23-2.27H21a1.13 1.13 0 0 0-1.13 1.13V21H18.3a4 4 0 0 0-3.58 2.2L6.21 40.05a4 4 0 0 0-.57 2.05v17.78a4 4 0 0 0 4 4H60.2a4 4 0 0 0 4-4V42.12a4 4 0 0 0-.57-2.05zM17 24.38a1.49 1.49 0 0 1 1.33-.82h1.62v2h-1.54a1.13 1.13 0 0 0-1.13 1.13v6.08h-1.4a1.13 1.13 0 0 0-1.13 1.13v4.24H10zm43.24 37H9.63a1.45 1.45 0 0 1-1.45-1.45V42.12a1.45 1.45 0 0 1 1.45-1.45H23a.1.1 0 0 1 .09.06l1.63 3.62a2.62 2.62 0 0 0 2.38 1.54h15.63a2.62 2.62 0 0 0 2.38-1.54l1.63-3.62a.1.1 0 0 1 .09-.06H60.2a1.45 1.45 0 0 1 1.45 1.45v17.76a1.45 1.45 0 0 1-1.45 1.45zM50.07 22.11a1.25 1.25 0 0 0 1.25 1.25h8.07a1.25 1.25 0 1 0 0-2.5h-6.82v-8.2a1.25 1.25 0 0 0-2.5 0z"
  }), _react["default"].createElement("path", {
    d: "M36.3 21.33A15.18 15.18 0 1 0 51.48 6.15 15.2 15.2 0 0 0 36.3 21.33zm15.18-12a12 12 0 1 1-12 12 12 12 0 0 1 12-11.95z"
  })),
  height: undefined,
  width: undefined
});
IconFileBoxTime.displayName = 'IconFileBoxTime';
var _default = IconFileBoxTime;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/file-box-time.js
// module id = 572
// module chunks = 0